import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { LoanProductPartnerOptionDto } from "../dto/loan-product-partner.dto"
import { proposalService } from "../services/proposal.service"

export function useProposalLoanProductPartners(
  proposalId: string | undefined,
): UseQueryResult<LoanProductPartnerOptionDto[]> {
  return useQuery<LoanProductPartnerOptionDto[]>({
    queryKey: queryKeys.loanProductPartners.byProposal(proposalId),
    queryFn: async () => {
      if (!proposalId) {
        return []
      }

      const partnerResponse =
        await proposalService.fetchProposalLoanProductPartners(proposalId)

      return partnerResponse.partners
    },
    enabled: !!proposalId,
  })
}
